/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Types from '@whitewater-guide/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RiverBreadcrumbQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type RiverBreadcrumbQuery = {
  __typename?: 'Query';
  node?:
    | {
        __typename?: 'River';
        id: string;
        name: string;
        altNames: Array<string>;
      }
    | null
    | undefined;
};

export const RiverBreadcrumbDocument = gql`
  query riverBreadcrumb($id: ID!) {
    node: river(id: $id) {
      id
      name
      altNames
    }
  }
`;

/**
 * __useRiverBreadcrumbQuery__
 *
 * To run a query within a React component, call `useRiverBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useRiverBreadcrumbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRiverBreadcrumbQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRiverBreadcrumbQuery(
  baseOptions: Apollo.QueryHookOptions<
    RiverBreadcrumbQuery,
    RiverBreadcrumbQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RiverBreadcrumbQuery, RiverBreadcrumbQueryVariables>(
    RiverBreadcrumbDocument,
    options,
  );
}
export function useRiverBreadcrumbLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RiverBreadcrumbQuery,
    RiverBreadcrumbQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RiverBreadcrumbQuery,
    RiverBreadcrumbQueryVariables
  >(RiverBreadcrumbDocument, options);
}
export type RiverBreadcrumbQueryHookResult = ReturnType<
  typeof useRiverBreadcrumbQuery
>;
export type RiverBreadcrumbLazyQueryHookResult = ReturnType<
  typeof useRiverBreadcrumbLazyQuery
>;
export type RiverBreadcrumbQueryResult = Apollo.QueryResult<
  RiverBreadcrumbQuery,
  RiverBreadcrumbQueryVariables
>;
